// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1262":"31d6cfe0","2478":"60683b60","2698":"31d6cfe0","8965":"0fa95999"}[chunkId] + ".chunk.css";
};